import React, { useEffect, useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNotification } from '../contexts/NotificationContext';
import { api } from '../api'; // Importar a instância do axios

function SessionManager({ setIsLoggedIn, onInitialCheckComplete }) {
  const { setUser } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { addNotification } = useNotification();
  const workspaceRoutes = ['/consultation-manager', '/chat', '/material-producer', '/profile', '/neuralweb', '/academic'];
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  useEffect(() => {
    if (initialCheckDone) {
      return;
    }

    const checkLoginStatus = async () => {
      // A nova lógica verifica se existe um token.
      const token = localStorage.getItem('authToken');
      if (!token) {
        // Se não há token, o usuário não está logado.
        setIsLoggedIn(false);
        setUser(null);
        if (workspaceRoutes.includes(location.pathname)) {
          navigate('/login', { replace: true });
        }
        // Marca a verificação como concluída e finaliza.
        setInitialCheckDone(true);
        if (onInitialCheckComplete) onInitialCheckComplete();
        return;
      }

      // Se há um token, tenta buscar os dados do usuário.
      try {
        // Usa a função getUserInfo do nosso api.js, que já envia o token.
        const userData = await api.get('/user/info');
        
        // Se a chamada foi bem-sucedida (não lançou erro), o token é válido.
        setUser(userData.data);
        setIsLoggedIn(true);

      } catch (error) {
        // Se a chamada falhou (provavelmente com 401), o token é inválido ou expirou.
        console.error('Falha na verificação da sessão com token:', error.message);
        localStorage.removeItem('authToken'); // Limpa o token inválido
        setIsLoggedIn(false);
        setUser(null);
        if (workspaceRoutes.includes(location.pathname)) {
          navigate('/login', { replace: true });
        }
      } finally {
        setInitialCheckDone(true);
        if (onInitialCheckComplete) onInitialCheckComplete();
      }
    };

    checkLoginStatus();

  }, [initialCheckDone, setUser, setIsLoggedIn, navigate, addNotification, onInitialCheckComplete, location.pathname]); // Removido workspaceRoutes e API_URL

  return null;
}

export default SessionManager;